export default __webpack_public_path__ + "static/media/7.8f4b7c2f.jpg";